import { createFileRoute } from '@tanstack/react-router'

import { NoteDetailPage } from '@/components/organisms/notes/note-detail-page'

/**
 * Reading a note from inside an errand — reached from the errand's "Händelser" timeline or from a
 * note pill in its chat. Renders the exact same page as /notes/$noteId; the errand only changes
 * where "back" returns to, and keeps the sidebar and breadcrumb on Ärenden rather than sending the
 * user off into Anteckningar mid-errand. Same reasoning as the /upload and /notes/new twins.
 *
 * The `$id_` suffix un-nests this from the `/errands/$id` route: that route is the errand detail
 * page, not a layout, so nesting under it would render the detail page and never reach this one.
 */
const ErrandNoteRoute = () => {
  const { id, noteId } = Route.useParams()

  return <NoteDetailPage errandId={id} noteId={noteId} />
}

export const Route = createFileRoute('/_authenticated/errands/$id_/notes/$noteId')({
  component: ErrandNoteRoute,
})
